import RenderingMode from "./RenderingMode";
import React, { useEffect } from 'react';

function App() {



  //let main = window.HRMRecruitmentComponentConfiguration.componentUrl + "/static/css/main.css";
  // <link rel="stylesheet" href={main} type="text/css" />

  let bs = window.HRMRecruitmentComponentConfiguration.componentUrl + "/bs.css";
  let site = window.HRMRecruitmentComponentConfiguration.componentUrl + "/site.css";
  let customStyleSheet = window.HRMRecruitmentComponentConfiguration.customStyleSheet;
  const captchaSiteKey = window.HRMRecruitmentComponentConfiguration.captchaSiteKey;
  let renderingMode = window.HRMRecruitmentComponentConfiguration.renderingMode ?? 1;
  return (
      <>
        
        <link rel="stylesheet" href={bs} type="text/css" />
        <link rel="stylesheet" href={site} type="text/css" />

        {customStyleSheet &&
          <link rel="stylesheet" href={customStyleSheet} type="text/css" />
        }

        <RenderingMode mode={renderingMode}></RenderingMode>
      </>
  );
}

export default App;